import React, { ReactNode } from 'react';

const baseStyles = (narrow: boolean = false) =>
  `flex flex-col w-11/12 mx-auto py-3.5 mb-10 ${narrow ? 'max-w-700' : 'max-w-6xl'}`;

type Props = {
  narrow?: boolean;
  children: ReactNode;
  classes?: string;
};

const defaultProps = {
  narrow: false,
  classes: '',
};

export default function StaticContentView({ narrow, children, classes }: Props) {
  return (
    <div className={`${classes} ${baseStyles(narrow)}`} id="hotels-container">
      {children}
    </div>
  );
}

StaticContentView.defaultProps = defaultProps;
